"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var React = __importStar(require("react"));
function Logo(_a) {
    var _b = _a.width, width = _b === void 0 ? 64 : _b, _c = _a.height, height = _c === void 0 ? 64 : _c, className = _a.className;
    return (React.createElement("svg", { height: "".concat(height), viewBox: "0 0 68 51", className: "".concat(className), width: "".concat(width) },
        React.createElement("path", { fill: "#EBEBEB", d: "M3.461 50.66h60.231c1.913 0 3.461-1.55 3.461-3.462V9.106a3.46 3.46 0 00-3.46-3.461H3.46A3.461 3.461 0 000 9.106V47.2a3.462 3.462 0 003.461 3.462z" }),
        React.createElement("path", { fill: "#fff", d: "M64.062 8.627H3.092v38.585h60.97V8.627z" }),
        React.createElement("path", { fill: "#009CFF", d: "M16.57 32.429H9.113v12.327h7.455V32.43zM25.846 27.42h-7.455v17.336h7.456V27.42zM35.334 24.738h-7.455v20.018h7.455V24.738zM44.9 21.344h-7.455v23.413H44.9V21.344zM54.36 14.04h-7.454v30.717h7.454V14.04z" }),
        React.createElement("path", { fill: "#009CFF", d: "M37.445 44.605H44.9V35.37c-2.269 1.744-4.806 3.163-7.455 4.315v4.92zM35.334 44.605h-7.455v-1.856c2.462-.558 4.987-1.28 7.455-2.209v4.065z" }),
        React.createElement("path", { fill: "#72CFE9", d: "M16.57 44.599H9.113s3 .131 7.455-.2v.2z" }),
        React.createElement("path", { fill: "#009CFF", d: "M18.391 44.605h7.456v-1.427a78.357 78.357 0 01-7.456 1.072v.355zM46.906 33.675c4.121-3.846 7.01-9.034 7.454-16.028v26.958h-7.454" }),
        React.createElement("path", { fill: "#009CFF", stroke: "#fff", strokeMiterlimit: "10", d: "M11.201 22.454l13.25-11.592 6.624 5.344 9.108-8.055-2.785-3.237L48.915 1l-4.291 11.517-3.086-2.56L31.3 23.132l-7.15-7.226-8.206 11.442-4.743-4.893z" })));
}
Logo.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
exports.default = Logo;
